import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import './index.css'

import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';

import App from './App'
import * as serviceWorker from './serviceWorker'
import reportError from "./commons/utils/reportError"
import { store, persistor } from 'redux/store'

window.onerror = function(message, source, lineNum, colNum, error) {
  reportError({message, source, lineNum, colNum, error});
}

ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <I18nextProvider i18n={i18n}>
        <App />
      </I18nextProvider>
    </PersistGate>
  </Provider>
  , document.getElementById('root')
)

serviceWorker.unregister()

console.info('AppVersion: ', process.env.REACT_APP_VERSION)